module.exports = __webpack_public_path__ + "static/media/nav-appointments-white.2bb1deec.svg";